var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M590.813 204.61C590.821 213.271 589.63 221.891 587.276 230.226C585 238.261 581.653 245.953 577.324 253.094C577.324 278.968 559.858 301.33 534.505 311.969C523.912 316.37 512.547 318.617 501.076 318.579H112.157C91.3697 318.579 72.1063 312.971 56.3083 303.417C51.787 300.695 47.498 297.605 43.4849 294.177C25.9258 279.087 15.0391 258.233 15.0391 235.199C5.18439 220.025 -0.0410447 202.31 0.000242788 184.216C0.000242788 146.33 22.4088 113.752 54.511 99.3692C58.7739 97.4602 63.1786 95.8855 67.6855 94.6592C69.2796 94.2254 70.8909 93.8364 72.5195 93.4921C76.8607 92.5676 81.2641 91.9634 85.694 91.6845C87.295 91.5847 88.9045 91.5278 90.5227 91.5141H91.411C93.1979 91.5141 94.9693 91.576 96.7304 91.6793L97.3088 90.6981C98.0181 89.5137 98.7445 88.3414 99.4882 87.1811C100.831 85.0671 102.239 82.9841 103.713 80.9321C105.255 78.7665 106.865 76.6353 108.542 74.5385L108.97 74.0221C109.92 72.8377 110.891 71.6671 111.883 70.5102C114.982 66.8986 118.252 63.3954 121.695 60.0006C158.936 23.4982 217.279 0 282.868 0C333.903 0 380.553 14.2281 416.286 37.7366C429.823 30.076 445.115 26.0564 460.669 26.0701C511.147 26.0701 552.08 67.5768 552.08 118.777C552.073 122.017 551.9 125.254 551.564 128.476C563.731 137.089 573.649 148.503 580.48 161.753C587.311 175.004 590.855 189.703 590.813 204.61V204.61Z",
    fill: "#049FD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.706 59.9785V70.4882H111.893C114.968 66.8799 118.238 63.3767 121.706 59.9785Z",
    fill: "#049FD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.712 57.3154H126.538V70.4899H139.712V57.3154Z",
    fill: "#049FD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.717 57.3154H144.542V70.4899H157.717V57.3154Z",
    fill: "#049FD9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.726 57.3154H162.551V70.4899H175.726V57.3154Z",
    fill: "#049FD9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 57.3154H180.554V70.4899H193.728V57.3154Z",
    fill: "#049FD9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.737 57.3154H198.562V70.4899H211.737V57.3154Z",
    fill: "#049FD9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.744 57.3154H216.569V70.4899H229.744V57.3154Z",
    fill: "#049FD9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.749 57.3154H234.574V70.4899H247.749V57.3154Z",
    fill: "#049FD9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.758 57.3154H252.583V70.4899H265.758V57.3154Z",
    fill: "#049FD9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.76 57.3154H270.586V70.4899H283.76V57.3154Z",
    fill: "#049FD9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.769 57.3154H288.595V70.4899H301.769V57.3154Z",
    fill: "#049FD9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.776 57.3154H306.602V70.4899H319.776V57.3154Z",
    fill: "#049FD9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.781 57.3154H324.606V70.4899H337.781V57.3154Z",
    fill: "#049FD9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.788 57.3154H342.613V70.4899H355.788V57.3154Z",
    fill: "#049FD9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.799 57.3154H360.624V70.4899H373.799V57.3154Z",
    fill: "#049FD9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.801 57.3154H378.627V70.4899H391.801V57.3154Z",
    fill: "#049FD9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.808 57.3154H396.634V70.4899H409.808V57.3154Z",
    fill: "#049FD9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M427.813 57.3154H414.638V70.4899H427.813V57.3154Z",
    fill: "#049FD9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M445.82 57.3154H432.645V70.4899H445.82V57.3154Z",
    fill: "#049FD9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.831 57.3154H450.656V70.4899H463.831V57.3154Z",
    fill: "#049FD9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.833 57.3154H468.659V70.4899H481.833V57.3154Z",
    fill: "#049FD9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M499.84 57.3154H486.666V70.4899H499.84V57.3154Z",
    fill: "#049FD9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 57.3154H504.67V70.4899H517.845V57.3154Z",
    fill: "#049FD9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103.701 80.9277V87.1767H99.4766C100.819 85.049 102.227 82.966 103.701 80.9277Z",
    fill: "#049FD9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.705 74H108.531V87.1745H121.705V74Z",
    fill: "#049FD9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.712 74H126.538V87.1745H139.712V74Z",
    fill: "#049FD9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.717 74H144.542V87.1745H157.717V74Z",
    fill: "#049FD9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.726 74H162.551V87.1745H175.726V74Z",
    fill: "#049FD9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 74H180.554V87.1745H193.728V74Z",
    fill: "#049FD9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.737 74H198.562V87.1745H211.737V74Z",
    fill: "#049FD9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M229.744 74H216.569V87.1745H229.744V74Z",
    fill: "#049FD9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M247.749 74H234.574V87.1745H247.749V74Z",
    fill: "#049FD9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.758 74H252.583V87.1745H265.758V74Z",
    fill: "#049FD9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M283.76 74H270.586V87.1745H283.76V74Z",
    fill: "#049FD9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M301.769 74H288.595V87.1745H301.769V74Z",
    fill: "#049FD9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M319.776 74H306.602V87.1745H319.776V74Z",
    fill: "#049FD9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M337.781 74H324.606V87.1745H337.781V74Z",
    fill: "#049FD9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.788 74H342.613V87.1745H355.788V74Z",
    fill: "#049FD9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M373.799 74H360.624V87.1745H373.799V74Z",
    fill: "#049FD9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M391.801 74H378.627V87.1745H391.801V74Z",
    fill: "#049FD9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.808 74H396.634V87.1745H409.808V74Z",
    fill: "#049FD9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.813 74H414.638V87.1745H427.813V74Z",
    fill: "#049FD9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M445.82 74H432.645V87.1745H445.82V74Z",
    fill: "#049FD9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.831 74H450.656V87.1745H463.831V74Z",
    fill: "#049FD9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M481.833 74H468.659V87.1745H481.833V74Z",
    fill: "#049FD9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M499.84 74H486.666V87.1745H499.84V74Z",
    fill: "#049FD9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 74H504.67V87.1745H517.845V74Z",
    fill: "#049FD9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.6848 94.6602V103.868H54.5103V99.3701C58.7731 97.4611 63.1779 95.8864 67.6848 94.6602V94.6602Z",
    fill: "#049FD9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6936 91.6836V103.867H72.519V93.4912L85.6936 91.6836Z",
    fill: "#049FD9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M103.696 90.6934H90.5215V103.868H103.696V90.6934Z",
    fill: "#049FD9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.705 90.6934H108.531V103.868H121.705V90.6934Z",
    fill: "#049FD9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.712 90.6934H126.538V103.868H139.712V90.6934Z",
    fill: "#049FD9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M157.717 90.6934H144.542V103.868H157.717V90.6934Z",
    fill: "#049FD9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.726 90.6934H162.551V103.868H175.726V90.6934Z",
    fill: "#049FD9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 90.6934H180.554V103.868H193.728V90.6934Z",
    fill: "#049FD9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.737 90.6934H198.562V103.868H211.737V90.6934Z",
    fill: "#049FD9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.744 90.6934H216.569V103.868H229.744V90.6934Z",
    fill: "#049FD9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M247.749 90.6934H234.574V103.868H247.749V90.6934Z",
    fill: "#049FD9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.758 90.6934H252.583V103.868H265.758V90.6934Z",
    fill: "#049FD9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M283.76 90.6934H270.586V103.868H283.76V90.6934Z",
    fill: "#049FD9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M301.769 90.6934H288.595V103.868H301.769V90.6934Z",
    fill: "#049FD9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.776 90.6934H306.602V103.868H319.776V90.6934Z",
    fill: "#049FD9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M337.781 90.6934H324.606V103.868H337.781V90.6934Z",
    fill: "#049FD9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.788 90.6934H342.613V103.868H355.788V90.6934Z",
    fill: "#049FD9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M373.799 90.6934H360.624V103.868H373.799V90.6934Z",
    fill: "#049FD9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.801 90.6934H378.627V103.868H391.801V90.6934Z",
    fill: "#049FD9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M409.808 90.6934H396.634V103.868H409.808V90.6934Z",
    fill: "#049FD9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M427.813 90.6934H414.638V103.868H427.813V90.6934Z",
    fill: "#049FD9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M445.82 90.6934H432.645V103.868H445.82V90.6934Z",
    fill: "#049FD9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.831 90.6934H450.656V103.868H463.831V90.6934Z",
    fill: "#049FD9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M481.833 90.6934H468.659V103.868H481.833V90.6934Z",
    fill: "#049FD9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M499.84 90.6934H486.666V103.868H499.84V90.6934Z",
    fill: "#049FD9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 90.6934H504.67V103.868H517.845V90.6934Z",
    fill: "#049FD9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.6848 107.378H54.5103V120.552H67.6848V107.378Z",
    fill: "#049FD9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6936 107.378H72.519V120.552H85.6936V107.378Z",
    fill: "#049FD9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.696 107.378H90.5215V120.552H103.696V107.378Z",
    fill: "#049FD9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.705 107.378H108.531V120.552H121.705V107.378Z",
    fill: "#049FD9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M139.712 107.378H126.538V120.552H139.712V107.378Z",
    fill: "#049FD9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M157.717 107.378H144.542V120.552H157.717V107.378Z",
    fill: "#049FD9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.726 107.378H162.551V120.552H175.726V107.378Z",
    fill: "#049FD9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 107.378H180.554V120.552H193.728V107.378Z",
    fill: "#049FD9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.737 107.378H198.562V120.552H211.737V107.378Z",
    fill: "#049FD9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.744 107.378H216.569V120.552H229.744V107.378Z",
    fill: "#049FD9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M247.749 107.378H234.574V120.552H247.749V107.378Z",
    fill: "#049FD9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M265.758 107.378H252.583V120.552H265.758V107.378Z",
    fill: "#049FD9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.76 107.378H270.586V120.552H283.76V107.378Z",
    fill: "#049FD9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M301.769 107.378H288.595V120.552H301.769V107.378Z",
    fill: "#049FD9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M319.776 107.378H306.602V120.552H319.776V107.378Z",
    fill: "#049FD9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M337.781 107.378H324.606V120.552H337.781V107.378Z",
    fill: "#049FD9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.788 107.378H342.613V120.552H355.788V107.378Z",
    fill: "#049FD9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.799 107.378H360.624V120.552H373.799V107.378Z",
    fill: "#049FD9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.801 107.378H378.627V120.552H391.801V107.378Z",
    fill: "#049FD9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.808 107.378H396.634V120.552H409.808V107.378Z",
    fill: "#049FD9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.813 107.378H414.638V120.552H427.813V107.378Z",
    fill: "#049FD9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M445.82 107.378H432.645V120.552H445.82V107.378Z",
    fill: "#049FD9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M463.831 107.378H450.656V120.552H463.831V107.378Z",
    fill: "#049FD9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M481.833 107.378H468.659V120.552H481.833V107.378Z",
    fill: "#049FD9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M499.84 107.378H486.666V120.552H499.84V107.378Z",
    fill: "#049FD9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 107.378H504.67V120.552H517.845V107.378Z",
    fill: "#049FD9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.6848 124.071H54.5103V137.246H67.6848V124.071Z",
    fill: "#049FD9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6936 124.071H72.519V137.246H85.6936V124.071Z",
    fill: "#049FD9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.696 124.071H90.5215V137.246H103.696V124.071Z",
    fill: "#049FD9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.705 124.071H108.531V137.246H121.705V124.071Z",
    fill: "#049FD9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.712 124.071H126.538V137.246H139.712V124.071Z",
    fill: "#049FD9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M157.717 124.071H144.542V137.246H157.717V124.071Z",
    fill: "#049FD9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.726 124.071H162.551V137.246H175.726V124.071Z",
    fill: "#049FD9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 124.071H180.554V137.246H193.728V124.071Z",
    fill: "#049FD9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.737 124.071H198.562V137.246H211.737V124.071Z",
    fill: "#049FD9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.744 124.071H216.569V137.246H229.744V124.071Z",
    fill: "#049FD9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M247.749 124.071H234.574V137.246H247.749V124.071Z",
    fill: "#049FD9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.758 124.071H252.583V137.246H265.758V124.071Z",
    fill: "#049FD9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M283.76 124.071H270.586V137.246H283.76V124.071Z",
    fill: "#049FD9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M301.769 124.071H288.595V137.246H301.769V124.071Z",
    fill: "#049FD9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M319.776 124.071H306.602V137.246H319.776V124.071Z",
    fill: "#049FD9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.781 124.071H324.606V137.246H337.781V124.071Z",
    fill: "#049FD9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M355.788 124.071H342.613V137.246H355.788V124.071Z",
    fill: "#049FD9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.799 124.071H360.624V137.246H373.799V124.071Z",
    fill: "#049FD9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.801 124.071H378.627V137.246H391.801V124.071Z",
    fill: "#049FD9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.808 124.071H396.634V137.246H409.808V124.071Z",
    fill: "#049FD9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.813 124.071H414.638V137.246H427.813V124.071Z",
    fill: "#049FD9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.82 124.071H432.645V137.246H445.82V124.071Z",
    fill: "#049FD9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M463.831 124.071H450.656V137.246H463.831V124.071Z",
    fill: "#049FD9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.833 124.071H468.659V137.246H481.833V124.071Z",
    fill: "#049FD9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M499.84 124.071H486.666V137.246H499.84V124.071Z",
    fill: "#049FD9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 124.071H504.67V137.246H517.845V124.071Z",
    fill: "#049FD9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.6848 140.758H54.5103V153.932H67.6848V140.758Z",
    fill: "#049FD9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6936 140.758H72.519V153.932H85.6936V140.758Z",
    fill: "#049FD9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.696 140.758H90.5215V153.932H103.696V140.758Z",
    fill: "#049FD9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M121.705 140.758H108.531V153.932H121.705V140.758Z",
    fill: "#049FD9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.712 140.758H126.538V153.932H139.712V140.758Z",
    fill: "#049FD9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.717 140.758H144.542V153.932H157.717V140.758Z",
    fill: "#049FD9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.726 140.758H162.551V153.932H175.726V140.758Z",
    fill: "#049FD9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 140.758H180.554V153.932H193.728V140.758Z",
    fill: "#049FD9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.737 140.758H198.562V153.932H211.737V140.758Z",
    fill: "#049FD9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.744 140.758H216.569V153.932H229.744V140.758Z",
    fill: "#049FD9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M247.749 140.758H234.574V153.932H247.749V140.758Z",
    fill: "#049FD9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.758 140.758H252.583V153.932H265.758V140.758Z",
    fill: "#049FD9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M283.76 140.758H270.586V153.932H283.76V140.758Z",
    fill: "#049FD9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M301.769 140.758H288.595V153.932H301.769V140.758Z",
    fill: "#049FD9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.776 140.758H306.602V153.932H319.776V140.758Z",
    fill: "#049FD9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.781 140.758H324.606V153.932H337.781V140.758Z",
    fill: "#049FD9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.788 140.758H342.613V153.932H355.788V140.758Z",
    fill: "#049FD9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.799 140.758H360.624V153.932H373.799V140.758Z",
    fill: "#049FD9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.801 140.758H378.627V153.932H391.801V140.758Z",
    fill: "#049FD9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.808 140.758H396.634V153.932H409.808V140.758Z",
    fill: "#049FD9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.813 140.758H414.638V153.932H427.813V140.758Z",
    fill: "#049FD9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.82 140.758H432.645V153.932H445.82V140.758Z",
    fill: "#049FD9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.831 140.758H450.656V153.932H463.831V140.758Z",
    fill: "#049FD9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.833 140.758H468.659V153.932H481.833V140.758Z",
    fill: "#049FD9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M499.84 140.758H486.666V153.932H499.84V140.758Z",
    fill: "#049FD9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 140.758H504.67V153.932H517.845V140.758Z",
    fill: "#049FD9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M67.6848 157.449H54.5103V170.624H67.6848V157.449Z",
    fill: "#049FD9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.6936 157.449H72.519V170.624H85.6936V157.449Z",
    fill: "#049FD9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M103.696 157.449H90.5215V170.624H103.696V157.449Z",
    fill: "#049FD9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.705 157.449H108.531V170.624H121.705V157.449Z",
    fill: "#049FD9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M139.712 157.449H126.538V170.624H139.712V157.449Z",
    fill: "#049FD9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.717 157.449H144.542V170.624H157.717V157.449Z",
    fill: "#049FD9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.726 157.449H162.551V170.624H175.726V157.449Z",
    fill: "#049FD9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.728 157.449H180.554V170.624H193.728V157.449Z",
    fill: "#049FD9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.737 157.449H198.562V170.624H211.737V157.449Z",
    fill: "#049FD9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.744 157.449H216.569V170.624H229.744V157.449Z",
    fill: "#049FD9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.749 157.449H234.574V170.624H247.749V157.449Z",
    fill: "#049FD9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M265.758 157.449H252.583V170.624H265.758V157.449Z",
    fill: "#049FD9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.76 157.449H270.586V170.624H283.76V157.449Z",
    fill: "#049FD9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M301.769 157.449H288.595V170.624H301.769V157.449Z",
    fill: "#049FD9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.776 157.449H306.602V170.624H319.776V157.449Z",
    fill: "#049FD9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M337.781 157.449H324.606V170.624H337.781V157.449Z",
    fill: "#049FD9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.788 157.449H342.613V170.624H355.788V157.449Z",
    fill: "#049FD9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.799 157.449H360.624V170.624H373.799V157.449Z",
    fill: "#049FD9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.801 157.449H378.627V170.624H391.801V157.449Z",
    fill: "#049FD9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.808 157.449H396.634V170.624H409.808V157.449Z",
    fill: "#049FD9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.813 157.449H414.638V170.624H427.813V157.449Z",
    fill: "#049FD9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.82 157.449H432.645V170.624H445.82V157.449Z",
    fill: "#049FD9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.831 157.449H450.656V170.624H463.831V157.449Z",
    fill: "#049FD9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.833 157.449H468.659V170.624H481.833V157.449Z",
    fill: "#049FD9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M499.84 157.449H486.666V170.624H499.84V157.449Z",
    fill: "#049FD9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M517.845 157.449H504.67V170.624H517.845V157.449Z",
    fill: "#049FD9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M379.338 205.916C389.284 205.916 397.346 197.854 397.346 187.908C397.346 177.962 389.284 169.899 379.338 169.899C369.392 169.899 361.33 177.962 361.33 187.908C361.33 197.854 369.392 205.916 379.338 205.916Z",
    fill: "#767D9F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M378.404 165C380.201 172.843 381.726 180.745 382.979 188.705C383.356 191.07 383.692 193.565 382.835 195.801C382.117 197.665 380.655 199.122 379.509 200.753C378.362 202.385 377.495 204.477 378.192 206.347C378.889 208.216 380.924 209.239 382.866 209.765C388.423 211.263 394.346 210.173 399.878 208.552C402.382 207.907 404.783 206.913 407.01 205.598C409.354 204.11 411.275 202.045 413.042 199.917C421.103 190.141 426.381 178.407 431.35 166.746C428.157 167.036 424.942 166.563 421.968 165.365C418.995 164.167 416.349 162.279 414.25 159.856C412.215 157.465 410.723 154.134 411.869 151.211C408.507 153.055 404.515 153.179 400.895 154.439C398.65 155.296 396.489 156.359 394.439 157.615C391.967 159.044 389.509 160.5 387.065 161.984C384.271 163.668 381.652 165.165 378.404 165Z",
    fill: "#AE6E79"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M416.069 178.521C412.914 184.661 408.808 190.564 402.946 194.221C397.085 197.877 389.193 198.869 383.321 195.254C380.429 193.487 378.24 190.802 375.714 188.54C373.189 186.278 370.033 184.341 366.64 184.635C362.901 184.961 359.973 187.879 357.468 190.673C353.667 194.918 349.995 199.344 347.305 204.369C342.14 214.026 340.916 225.316 341.143 236.264C341.371 247.213 342.956 258.105 342.992 269.054C343.044 282.522 340.761 295.883 338.453 309.15C359.679 306.537 380.93 312.249 402.203 314.413C415.816 315.812 429.533 315.782 443.219 315.745C445.625 315.745 448.187 315.683 450.191 314.351C451.416 313.457 452.406 312.281 453.078 310.922C454.968 307.436 455.727 303.459 456.254 299.529C457.591 289.603 457.633 279.553 457.669 269.534C457.762 245.261 457.85 220.9 454.766 196.818C454.007 190.895 453.036 184.94 450.764 179.399C448.492 173.857 444.784 168.76 439.598 165.79C436.267 163.879 428.547 160.554 424.622 162.48C420.216 164.628 418.181 174.41 416.069 178.521Z",
    fill: "#767D9F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M417.639 247.063C416.839 232.086 413.58 216.102 420.516 202.809C422.22 199.545 416.105 195.47 417.996 192.309C420.302 188.456 422.052 184.295 423.191 179.951C423.584 178.458 423.899 176.878 423.527 175.38C422.84 172.648 420.139 171.022 417.846 169.359C415.315 167.52 414.014 161.917 413.198 158.885C412.382 155.854 419.69 159.505 422.628 158.425C426.708 156.933 431.893 157.873 435.963 159.386C438.235 160.223 440.704 160.295 443.126 160.357C447.831 160.481 452.551 160.6 457.22 160.021C459.316 159.758 461.418 159.36 463.526 159.479C468.902 159.784 473.576 163.461 476.757 167.809C479.938 172.158 481.963 177.224 484.571 181.934C486.745 185.859 489.337 189.567 491.191 193.652C492.834 197.267 493.872 201.151 494.9 205.014L497.549 214.925C498.012 216.342 498.232 217.828 498.2 219.319C498.065 220.905 497.363 222.382 496.65 223.792C493.955 229.018 490.724 233.949 487.008 238.505C481.436 245.338 474.67 251.499 471.36 259.68C470.069 262.866 469.351 266.254 468.695 269.632C466.051 283.14 464.171 296.788 463.066 310.508C457.031 307.716 450.706 305.601 444.205 304.202C440.965 303.509 437.689 302.992 434.393 302.653C431.506 302.354 427.782 302.922 425.035 302.137C420.438 300.83 419.932 293.058 419.235 288.988C418.12 282.507 417.898 275.912 417.856 269.363C417.805 261.916 418.037 254.484 417.639 247.063Z",
    fill: "#4C4981"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M316.7 219.056C318.874 231.451 321.27 243.882 325.996 255.527C325.877 255.641 325.758 255.744 325.639 255.848C325.221 256.204 324.787 256.54 324.333 256.88C323.274 257.624 322.112 258.254 321.234 259.225C320.902 259.597 320.639 260.025 320.459 260.49C320.297 260.854 320.213 261.247 320.213 261.645C320.213 262.042 320.297 262.436 320.459 262.799C317.996 263.889 315.135 263.553 312.372 263.45C309.991 263.362 307.682 263.45 305.772 264.756C303.117 266.584 302.317 270.096 301.888 273.288C301.73 274.452 301.594 275.617 301.48 276.784C301.37 277.869 301.28 278.957 301.211 280.048C300.977 283.659 300.945 287.279 301.113 290.894C301.141 291.555 301.177 292.216 301.222 292.877C292.783 292.675 285.093 288.275 277.816 283.999C276.154 283.023 274.439 281.995 273.36 280.384C272.365 278.801 271.944 276.925 272.167 275.07C272.167 274.806 272.213 274.553 272.249 274.285C272.48 272.752 272.877 271.249 273.432 269.802C275.708 263.638 279.064 257.928 283.342 252.94C285.191 250.781 287.273 248.669 288.135 245.958C288.512 244.775 288.651 243.52 289.034 242.343C290.748 237.24 296.935 234.828 299.053 229.876C299.569 228.693 299.807 227.397 300.447 226.26C301.024 225.316 301.767 224.485 302.642 223.807C303.019 223.492 303.411 223.188 303.799 222.883C307.428 220.039 310.924 217.035 314.288 213.871C314.914 213.282 315.534 212.687 316.147 212.084C316.065 214.421 316.251 216.761 316.7 219.056V219.056Z",
    fill: "#4C4981"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M368.74 182.397C367.996 183.182 367.19 183.921 366.4 184.654L366.189 184.845L365.352 185.62C363.833 186.93 362.519 188.46 361.453 190.159L361.365 190.304C358.731 195.019 359.707 200.824 360.441 206.179C361.35 212.853 361.759 219.586 361.665 226.321C361.53 235.617 360.435 244.851 360.415 254.136C360.415 256.244 360.461 258.346 360.554 260.453C360.704 263.877 360.962 267.295 361.272 270.714C361.608 274.464 362.011 278.208 362.388 281.952C362.687 284.849 362.971 287.742 363.209 290.634C363.327 292.131 363.441 293.624 363.534 295.122C363.643 296.877 363.73 298.639 363.782 300.394C363.818 301.51 363.839 302.62 363.839 303.736C363.839 304.371 363.839 305.001 363.839 305.631C363.839 306.84 363.806 308.045 363.741 309.246C363.672 310.792 363.567 312.342 363.426 313.894C363.266 315.583 362.981 317.427 361.794 318.615C361.721 318.687 361.644 318.754 361.566 318.821L359.893 318.615C348.358 317.234 336.713 317.026 325.136 317.995C325.389 316.249 325.622 314.509 325.849 312.758C325.952 311.932 326.056 311.1 326.154 310.269C326.267 309.319 326.376 308.368 326.479 307.418C326.598 306.385 326.706 305.352 326.81 304.319C327.078 301.658 327.314 298.995 327.517 296.33C327.817 292.443 328.044 288.549 328.199 284.648C328.275 282.785 328.333 280.921 328.375 279.055C328.433 276.741 328.461 274.426 328.457 272.109C328.457 269.857 328.438 267.602 328.4 265.343C328.4 264.6 328.369 263.856 328.307 263.117C328.263 262.452 328.171 261.792 328.034 261.139C327.65 259.636 327.132 258.17 326.484 256.76C326.371 256.491 326.262 256.244 326.154 255.96C326.092 255.82 326.035 255.675 325.978 255.536C328.953 252.887 331.07 249.339 333.105 245.848C336.405 240.223 339.783 234.351 340.335 227.855C340.888 221.358 337.66 214.06 331.452 212.077C329.764 211.561 327.977 211.416 326.236 211.111C324.594 210.822 321.17 210.166 319.27 208.989C318.237 210.049 317.204 211.091 316.171 212.113C316.234 210.553 316.615 209.022 317.292 207.615L318.025 207.651C317.965 207.486 317.937 207.311 317.942 207.135C317.942 206.582 318.324 205.957 319.14 205.265C321.573 203.2 325.4 202.74 326.934 199.946C327.574 198.784 327.682 197.4 328.199 196.181C329.681 192.705 333.937 191.425 336.498 188.646C339.06 185.868 339.7 181.932 341.771 178.834C343.318 176.571 345.464 174.783 347.968 173.669C348.175 173.571 348.387 173.473 348.598 173.385C352.885 171.552 357.977 171.133 362.419 171.144C364.143 171.144 368.616 171.195 370.806 172.068C371.161 172.195 371.486 172.394 371.761 172.652C374.095 175.193 370.465 180.559 368.74 182.397Z",
    fill: "#4C4981"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M317.469 207.255C321.459 206.054 325.647 205.657 329.791 206.089C333.935 206.521 337.952 207.772 341.608 209.77C345.326 211.835 348.663 214.717 350.708 218.436C353.781 224.013 353.646 230.737 353.429 237.105C353.321 240.292 353.182 243.592 351.777 246.453C350.15 249.763 347.082 252.036 343.953 253.895C341.992 255.146 339.844 256.075 337.59 256.647C334.12 257.401 330.515 256.761 327.018 256.131C323.217 255.429 319.137 254.582 316.498 251.751C314.949 250.109 314.102 247.976 313.265 245.89C312.064 242.877 310.859 239.868 309.65 236.862C307.559 231.641 306.851 227.298 309.614 222.211C310.869 219.892 312.403 217.723 313.642 215.389C314.262 214.201 316.483 207.559 317.469 207.255Z",
    fill: "#4C4981"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M534.52 296.531V311.973C523.926 316.374 512.562 318.621 501.091 318.583H361.811C361.738 318.656 361.661 318.723 361.583 318.79L359.91 318.583H112.156C91.3691 318.583 72.1057 312.975 56.3076 303.42V279.845L175.462 266.092H175.555L244.944 271.969L262.901 273.518L272.228 274.308L291.533 275.946L301.464 276.787L315.925 278.017L317.959 278.187L328.381 279.07L342.521 280.232L362.405 281.916L395.55 284.73L418.868 286.708L457.157 289.957L464.439 290.571L465.224 290.638L465.905 290.695L475.522 291.511L486.078 292.41L487.302 292.513L534.52 296.531Z",
    fill: "#504F60"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M394.563 295.963L245.238 270.477L239.449 299.754L307.898 307.95L328.975 310.589L386.951 299.17L394.563 295.963Z",
    fill: "#9C9CA1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M317.267 309.123L392.079 295.06C392.454 294.988 392.839 295 393.208 295.095C393.577 295.19 393.921 295.366 394.214 295.609C394.507 295.852 394.743 296.158 394.904 296.503C395.066 296.848 395.148 297.225 395.147 297.606V297.606C395.149 298.21 394.938 298.796 394.552 299.261C394.166 299.727 393.629 300.042 393.035 300.152L319.973 313.832L317.267 309.123Z",
    fill: "#9C9CA1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M349.721 264.899C352.05 264.682 354.41 264.316 356.507 263.283C359.089 261.997 361.098 259.781 363.489 258.149C368.746 254.534 375.78 254.049 381.807 256.125C387.834 258.201 392.864 262.648 396.387 267.957C398.726 271.494 400.482 276.008 398.829 279.912C398.262 281.106 397.548 282.223 396.702 283.238L392.394 288.868C391.576 290.051 390.592 291.11 389.471 292.013C387.86 293.185 385.856 293.665 383.883 293.955C378.642 294.719 373.307 294.285 368.023 294.636C358.949 295.241 350.087 298.164 340.993 298.065C335.766 298.009 330.607 296.955 325.499 295.902L302.895 291.254C298.959 290.448 294.513 289.27 292.659 285.702C291.827 284.096 291.672 282.236 291.574 280.429C291.306 275.45 291.574 269.914 295.024 266.325C298.267 262.958 303.395 261.894 307.269 259.404C312.01 256.352 313.575 257.339 318.574 259.632C328.327 264.049 339.058 265.863 349.721 264.899V264.899Z",
    fill: "#AE6E79"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M349.721 264.899C352.05 264.682 354.41 264.316 356.507 263.283C359.089 261.997 361.098 259.781 363.489 258.149C368.746 254.534 375.78 254.049 381.807 256.125C387.834 258.201 392.864 262.648 396.387 267.957C398.726 271.494 400.482 276.008 398.829 279.912C398.262 281.106 397.548 282.223 396.702 283.238L392.394 288.868C391.576 290.051 390.592 291.11 389.471 292.013C387.86 293.185 385.856 293.665 383.883 293.955C378.642 294.719 373.307 294.285 368.023 294.636C358.949 295.241 350.087 298.164 340.993 298.065C335.766 298.009 330.607 296.955 325.499 295.902L302.895 291.254C298.959 290.448 294.513 289.27 292.659 285.702C291.827 284.096 291.672 282.236 291.574 280.429C291.306 275.45 291.574 269.914 295.024 266.325C298.267 262.958 303.395 261.894 307.269 259.404C312.01 256.352 313.575 257.339 318.574 259.632C328.327 264.049 339.058 265.863 349.721 264.899V264.899Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M440.497 257.819C434.155 260.272 427.776 262.736 421.135 264.197C410 266.65 398.349 266.263 387.303 269.067C381.467 270.555 375.667 272.951 369.671 272.466C366.991 272.249 364.403 271.433 361.795 270.813C347.144 267.198 330.489 268.37 318.59 277.666C314.52 280.842 311.189 284.803 308.168 289.028C307.521 289.94 307.084 290.984 306.888 292.085C306.692 293.186 306.742 294.317 307.033 295.396C307.325 296.476 307.851 297.478 308.575 298.33C309.299 299.183 310.202 299.865 311.22 300.328C315.847 302.456 320.804 303.778 325.877 304.237C332.658 304.836 339.47 303.876 346.214 302.915C356.223 301.495 366.237 300.069 376.22 298.474C379.804 297.9 383.388 297.306 386.993 296.852C412.934 293.573 439.345 297.56 465.353 294.822C467.982 294.544 470.657 294.182 473.048 293.061C479.101 290.221 482.096 282.732 480.846 276.153C479.597 269.573 474.773 264.104 468.968 260.747C464.103 257.922 458.856 256.781 453.439 255.583C448.408 254.411 445.341 255.96 440.497 257.819Z",
    fill: "#AE6E79"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M496.132 218.487C498.993 222.236 499.602 227.266 499.292 231.961C498.982 236.655 497.867 241.298 497.702 246.013C497.474 252.479 499.034 258.924 498.771 265.369C498.585 269.878 497.516 274.299 496.251 278.627C494.758 283.734 492.599 289.224 487.884 291.677C481.625 294.936 468.497 293.102 461.912 295.654C462.511 291.92 468.254 286.513 468.853 282.779C469.266 280.197 469.685 277.542 469.24 274.955C468.672 271.655 466.736 268.726 464.437 266.289C460.781 262.41 456.009 259.492 450.767 258.542C445.525 257.592 432.692 258.372 428.498 261.682C427.982 258.263 437.587 254.968 440.965 254.23C442.649 253.853 444.58 254.064 445.928 252.995C448.51 250.971 446.636 246.937 446.76 243.699C446.858 241.117 448.366 238.752 448.67 236.17C449.187 232.038 446.491 227.829 447.55 223.775C447.942 222.277 448.815 220.96 449.419 219.535C451.258 215.171 450.452 210.192 449.471 205.555C448.861 202.642 448.268 199.357 449.889 196.873C451.392 194.554 455.658 202.812 458.39 202.43C467.412 201.165 475.577 194.477 482.864 199.951C486.577 202.74 487.063 205.632 488.545 209.614C489.986 213.405 493.72 215.347 496.132 218.487Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M497.682 218.487C500.543 222.236 501.152 227.267 500.843 231.961C500.533 236.656 499.417 241.298 499.252 246.014C499.025 252.479 500.584 258.925 500.321 265.37C500.135 269.878 499.066 274.299 497.801 278.627C496.308 283.735 494.15 289.225 489.434 291.678C483.175 294.936 470.047 293.103 463.462 295.654C464.061 291.92 469.804 286.513 470.403 282.779C470.817 280.197 471.235 277.543 470.791 274.955C470.223 271.655 468.286 268.727 465.988 266.289C462.331 262.411 457.559 259.493 452.317 258.543C447.076 257.592 434.242 258.372 430.048 261.683C429.532 258.264 439.138 254.969 442.515 254.23C444.199 253.853 446.13 254.065 447.478 252.996C450.061 250.971 448.186 246.938 448.31 243.7C448.408 241.118 449.916 238.752 450.221 236.17C450.737 232.039 448.041 227.83 449.1 223.775C449.492 222.278 450.365 220.961 450.97 219.535C452.808 215.171 452.002 210.193 451.021 205.555C450.412 202.643 449.818 199.358 451.44 196.874C452.942 194.555 455.881 193.677 458.613 193.29C467.76 192.052 477.028 194.444 484.435 199.952C488.148 202.741 488.634 205.633 490.116 209.615C491.536 213.405 495.27 215.347 497.682 218.487Z",
    fill: "#4C4981"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M155.966 194.018L184.045 297.792C184.39 299.063 185.114 300.2 186.12 301.05C187.127 301.899 188.369 302.422 189.68 302.548L316.064 314.69C317.094 314.789 318.133 314.64 319.094 314.256C320.054 313.871 320.909 313.262 321.585 312.479C322.262 311.696 322.741 310.762 322.983 309.756C323.225 308.75 323.222 307.7 322.974 306.696L292.225 181.52C291.859 180.032 290.978 178.722 289.737 177.822C288.497 176.923 286.977 176.493 285.449 176.608L161.714 185.863C160.764 185.937 159.842 186.219 159.014 186.69C158.186 187.161 157.472 187.81 156.923 188.588C156.374 189.367 156.003 190.258 155.838 191.196C155.673 192.135 155.716 193.098 155.966 194.018V194.018Z",
    fill: "#9C9CA1"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M406.498 214.268C414.171 214.268 420.391 207.968 420.391 200.195C420.391 192.423 414.171 186.122 406.498 186.122C398.826 186.122 392.606 192.423 392.606 200.195C392.606 207.968 398.826 214.268 406.498 214.268Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M417.907 174.521C417.907 174.521 420.836 183.228 412.196 186.89L411.09 188.821L416.503 194.161C416.503 194.161 423.175 181.989 422.452 177.666C422.452 177.666 421.419 173.276 417.907 174.521Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M408.093 214.267C415.492 214.267 421.49 208.269 421.49 200.87C421.49 193.471 415.492 187.474 408.093 187.474C400.695 187.474 394.697 193.471 394.697 200.87C394.697 208.269 400.695 214.267 408.093 214.267Z",
    fill: "#049FD9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M422.518 179.645L420.39 176.133L417.292 175.694C417.953 164.131 414.952 160.686 414.952 160.686L414.255 160.619L411.218 160.324L405.506 154.396V152.712C413.532 153.667 417.968 157.479 420.364 161.946C424.599 169.786 422.518 179.645 422.518 179.645Z",
    fill: "#049FD9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M414.282 158.493V160.621L411.246 160.326L405.534 154.397C405.534 154.397 414.37 156.375 414.282 158.493Z",
    fill: "black",
    stroke: "#4C4981",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M422.519 179.647L420.392 176.135V161.969C424.601 169.788 422.519 179.647 422.519 179.647Z",
    fill: "black",
    stroke: "#4C4981",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M383.338 206.378C386.903 204.32 386.749 197.381 382.996 190.88C379.242 184.379 373.31 180.777 369.745 182.834C366.181 184.892 366.334 191.831 370.088 198.332C373.841 204.834 379.774 208.436 383.338 206.378Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M378.552 193.472C382.307 199.974 386.914 204.317 383.35 206.383C379.787 208.449 369.406 207.416 365.652 200.909C361.897 194.402 365.306 185.416 368.869 183.35C372.432 181.284 374.793 186.955 378.552 193.472Z",
    fill: "#049FD9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M411.985 146.628C411.985 167.404 397.767 187.427 376.99 187.427C367.012 187.427 357.442 183.463 350.387 176.407C343.331 169.352 339.367 159.782 339.367 149.804C339.367 139.825 343.331 130.256 350.387 123.2C357.442 116.144 367.012 112.181 376.99 112.181C397.767 112.201 411.985 125.846 411.985 146.628Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M376.99 186.415C397.769 186.415 414.613 169.571 414.613 148.792C414.613 128.013 397.769 111.169 376.99 111.169C356.212 111.169 339.367 128.013 339.367 148.792C339.367 169.571 356.212 186.415 376.99 186.415Z",
    fill: "#AE6E79"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M373.685 132.123C378.162 133.77 380.812 138.398 384.83 140.975C390.511 144.59 397.906 143.655 404.393 141.868C408.008 140.882 411.788 139.678 415.346 140.773C415.87 141.005 416.447 141.087 417.015 141.011C417.789 140.789 418.171 139.931 418.424 139.167C422.825 126.049 420.847 111.191 414.205 99.0547C412.491 95.9251 410.435 92.8987 407.605 90.7245C405.374 89.015 402.75 87.8943 400.106 86.9389C395.274 85.2034 390.276 83.9695 385.191 83.2567C384.293 83.0935 383.376 83.0639 382.47 83.1689C381.225 83.3703 380.109 84.0417 378.999 84.6407C374.243 87.19 368.97 88.6224 363.578 88.8291C356.348 89.1028 348.085 87.3986 342.512 92.0362C335.798 97.5983 337.472 108.449 333.118 115.999C330.236 120.993 324.679 124.619 323.765 130.305C323.527 132.043 323.638 133.811 324.091 135.505C326.218 144.254 334.688 151.03 343.715 151.19C345.102 151.296 346.49 151.011 347.723 150.369C348.531 149.817 349.244 149.139 349.835 148.36C355.749 141.357 362.514 128.012 373.685 132.123Z",
    fill: "#444053"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M418.423 135.36C418.17 136.125 417.788 136.982 417.013 137.204C416.446 137.28 415.869 137.198 415.345 136.966C411.787 135.872 407.986 137.075 404.397 138.061C397.905 139.848 390.494 140.804 384.834 137.168C380.811 134.586 378.166 129.938 373.684 128.316C362.513 124.184 355.748 137.55 349.819 144.553C349.228 145.332 348.514 146.011 347.707 146.562C346.473 147.204 345.085 147.489 343.699 147.383C334.702 147.223 326.228 140.447 324.074 131.699C323.955 131.182 323.852 130.666 323.774 130.149C323.774 130.196 323.774 130.237 323.749 130.284C323.511 132.022 323.621 133.79 324.074 135.484C326.202 144.233 334.677 151.009 343.699 151.169C345.085 151.274 346.473 150.99 347.707 150.348C348.514 149.796 349.228 149.118 349.819 148.339C355.748 141.336 362.513 127.991 373.684 132.102C378.166 133.749 380.811 138.376 384.834 140.953C390.515 144.569 397.905 143.634 404.397 141.847C408.012 140.86 411.787 139.657 415.345 140.752C415.869 140.984 416.446 141.066 417.013 140.99C417.788 140.768 418.17 139.91 418.423 139.146C420.198 133.779 420.982 128.133 420.737 122.485C420.585 126.866 419.806 131.201 418.423 135.36V135.36Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.326 257.483C239.657 255.457 239.004 253.478 238.337 251.455C238.033 251.44 237.765 251.414 237.498 251.413C234.576 251.406 231.654 251.401 228.733 251.4C226.827 251.4 225.285 250.656 224.129 249.118C224.089 249.065 224.03 249.025 223.938 248.94C222.208 249.567 220.462 250.2 218.734 250.826C219.183 254.442 216.936 256.311 215.013 256.756C212.498 257.337 210.219 255.878 209.404 253.883C208.368 251.348 209.417 248.846 211.505 247.614C212.724 246.894 214.054 246.794 215.406 247.217C216.741 247.634 217.641 248.584 218.394 249.826C220.071 249.22 221.736 248.621 223.439 248.006C222.951 246.265 222.829 244.582 223.646 242.938C224.457 241.307 225.791 240.352 227.532 239.866C227.877 238.613 228.389 237.444 229.286 236.418C227.769 234.93 226.302 233.489 224.806 232.022C223.675 232.761 222.507 233.104 221.208 232.698C220.3 232.413 219.572 231.882 219.067 231.075C218.032 229.422 218.316 227.484 219.558 226.177C220.854 224.813 222.926 224.635 224.512 225.698C225.421 226.307 225.904 227.178 226.137 228.236C226.373 229.32 226.028 230.275 225.526 231.258C227.016 232.718 228.499 234.172 230.003 235.644C232.963 233.431 236.013 233.287 239.199 235.187C240.15 233.713 241.091 232.251 242.067 230.737C241.843 230.5 241.648 230.283 241.444 230.079C239.044 227.682 239.943 223.323 243.416 222.215C245.399 221.583 247.525 222.398 248.638 223.983C249.859 225.722 249.821 228.003 248.55 229.65C247.323 231.241 245.694 231.773 243.752 231.393C243.641 231.371 243.529 231.348 243.419 231.319C243.31 231.292 243.202 231.258 243.013 231.203C242.025 232.736 241.035 234.27 240.018 235.847C240.343 236.249 240.671 236.624 240.959 237.026C241.238 237.416 241.477 237.835 241.73 238.234C245.864 238.517 248.602 242.024 247.841 246.348C248.344 246.594 252.446 247.545 253.994 247.77C254.463 246.7 255.165 245.822 256.355 245.484C257.166 245.253 257.97 245.259 258.767 245.581C260.473 246.27 261.192 248.149 260.957 249.48C260.605 251.481 258.865 252.556 257.491 252.529C256.477 252.508 255.605 252.208 254.895 251.489C254.208 250.793 253.856 249.933 253.87 248.867C251.711 248.385 249.589 247.91 247.453 247.433C246.683 248.954 245.614 250.089 244.141 250.797C242.692 251.493 241.153 251.671 239.423 251.357C240.073 253.375 240.663 255.201 241.27 257.083C241.691 257.083 242.071 257.086 242.452 257.083C243.539 257.074 244.504 257.419 245.379 258.072C247.345 259.541 247.975 262.449 246.551 264.683C245.596 266.183 244.198 267.007 242.433 267.003C239.446 266.997 237.41 264.571 237.491 261.918C237.546 260.148 238.328 258.744 239.828 257.78C239.963 257.691 240.104 257.615 240.326 257.483ZM245.711 262.048C245.858 260.559 244.615 258.715 242.41 258.632C240.606 258.562 239.134 260.166 239.075 262.037C239.027 263.588 240.413 265.405 242.434 265.401C244.198 265.397 245.786 263.844 245.711 262.048ZM210.6 251.946C210.607 253.772 212.105 255.29 213.899 255.292C215.722 255.294 217.217 253.751 217.207 251.879C217.197 250.023 215.753 248.61 213.87 248.617C212.009 248.623 210.592 250.066 210.6 251.946ZM247.906 226.762C248.007 225.094 246.485 223.609 244.801 223.595C243.193 223.582 241.632 225.119 241.683 226.779C241.738 228.512 243.074 229.972 244.819 229.95C246.826 229.926 248.022 228.201 247.906 226.762ZM224.608 228.917C224.73 227.86 223.591 226.608 222.306 226.617C221.074 226.626 219.991 227.853 220.033 228.892C220.089 230.261 221.013 231.256 222.349 231.249C223.649 231.241 224.606 230.251 224.608 228.917ZM259.401 248.929C259.421 247.932 258.682 246.949 257.472 246.918C256.139 246.883 255.457 247.97 255.416 248.893C255.37 249.938 256.373 251.009 257.4 250.958C258.734 250.888 259.414 249.897 259.401 248.929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.cdd772f22a27580985da885c574e8932.svg";
export { ForwardRef as ReactComponent };